import {Temp} from '@/models';

export default [
	{
		path: '/temps',
		name: 'temps',
		meta: {
			title: 'Liste des temps',
			granted: [ 'API_GET_TEMPS' ],
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/Temp.vue')
	},
	{
		path: '/temps/edit/:id',
		name: 'temps-edit',
		props: {
			slotData: () => ({
				component: import(/* webpackChunkName: "dashboard" */ '../components/Crud/Temp/Edit.vue'),
				class: Temp
			}),
		},
		meta: {
			title: 'Edition d\'un temps',
			granted: [ 'API_PUT_TEMPS' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/EditShow.vue')
	},
];